import React from 'react';

import { Skeleton } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import { ListingCardBase } from './ListingCardBase';

const useStyles = makeStyles()(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
  },

  media: {
    width: '100%',
    borderRadius: theme.utils.borderRadius('ref/radius/lg'),
  },
  mediaLarge: {
    aspectRatio: '4 / 3',
    maxHeight: theme.utils.calculateSize(62),
    height: 'auto',
  },
  mediaSmall: {
    aspectRatio: '4 / 3',
    height: 'auto',
  },

  details: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.utils.spacing('ref/spacing/2'),
    paddingBlock: theme.utils.spacing('ref/spacing/2'),
    paddingInline: theme.utils.spacing('ref/spacing/1'),
  },

  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.utils.spacing('ref/spacing/1'),
  },

  title: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.utils.spacing('ref/spacing/2'),
  },

  attributes: {
    display: 'flex',
    gap: theme.utils.spacing('ref/spacing/3'),
  },

  attribute: {
    borderRadius: theme.utils.borderRadius('ref/radius/xs'),
  },

  line: {
    borderRadius: theme.utils.borderRadius('ref/radius/xs'),
  },
}));

export const ListingCardSkeleton = ({
  className,
  size = 'lg',
}: {
  className?: string;
  size?: 'sm' | 'lg';
}) => {
  const { classes, cx, theme } = useStyles();

  return (
    <ListingCardBase.Container className={cx(classes.container, className)}>
      <Skeleton
        className={cx(
          classes.media,
          size === 'lg' ? classes.mediaLarge : classes.mediaSmall,
        )}
        variant="rectangular"
        width="100%"
      />

      <div className={classes.details}>
        <div className={classes.content}>
          <div className={classes.title}>
            <Skeleton
              className={classes.line}
              variant="rectangular"
              width="100%"
              height={theme.utils.dimension('ref/dimension/6')}
            />
            <Skeleton
              className={classes.line}
              variant="rectangular"
              width="100%"
              height={theme.utils.dimension('ref/dimension/5')}
            />
          </div>

          <div className={classes.attributes}>
            <Skeleton
              className={classes.attribute}
              variant="rectangular"
              width={theme.utils.dimension('ref/dimension/15')}
              height={theme.utils.dimension('ref/dimension/5')}
            />
            <Skeleton
              className={classes.attribute}
              variant="rectangular"
              width={theme.utils.calculateSize(16.25)}
              height={theme.utils.dimension('ref/dimension/5')}
            />
          </div>

          <Skeleton
            className={classes.line}
            variant="rectangular"
            width={theme.utils.calculateSize(35.25)}
            height={theme.utils.dimension('ref/dimension/5')}
          />
        </div>

        <Skeleton
          className={classes.line}
          variant="rectangular"
          width={theme.utils.calculateSize(35.25)}
          height={theme.utils.calculateSize(4.5)}
        />
      </div>
    </ListingCardBase.Container>
  );
};
